import request from 'utils/axios/service';
import { endpoints } from '../constants'

class PaymentReceiptService {
    async paymentReceiptApi() {
        return await request.get(endpoints.PAYMENT_RECEIPT);
    }
}

export default PaymentReceiptService;